import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import SuccessModal from "../SuccessModal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCustomerOrderChargesInfo,
  putCustomerOrderChargesInfoUpdate,
} from "../../services/OrderEdit/orderInfoEdit";
import BookingInfoDiscountsAdd from "./BookingInfoDiscountsAdd";
import BookingInfoDiscountsEdit from "./BookingInfoDiscountsEdit";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";

const BookingDiscountInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    storeCustomerId,
    bookingOrderId,
    enabledChargeDiscountByService,
    storeId,    
  } = location.state || {}; // Fallback to prevent undefined errors

   const {
      userProfileRole,
    } = getUserData();

  const userRole = userProfileRole;

  const { storeLocalData } = getStoreLocalData();

  const [discountData, setDiscountData] = useState([]);
  const [discountAmountPreviousValue, setDiscountAmountPreviousValue] = useState(
    {}
  );

  const fetchGarmentEditData = () => {
    getCustomerOrderChargesInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const charges = Res.filter(
            (user) => user.chargeDiscountType === "DISCOUNT"
          );
          setDiscountData(charges);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  useEffect(() => {
    fetchGarmentEditData();
  }, []);

  const [
    bookingInfoChargesEditModalVisible,
    setBookingInfoChargesEditModalVisible,
  ] = useState(false);
  const [
    bookingInfoChargesAddModalVisible,
    setBookingInfoChargesAddModalVisible,
  ] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const receiveDataFromBookingInfoCharges = ({ success }) => {
    if (success) {
      fetchGarmentEditData();
    }
  };

  const handleRemoveAppliedCharge = (item) => {
    const data = {
      ...item,
      amount: parseInt(0),
      count: parseInt(0),
      chargeDiscountAmount: parseInt(0),
    };

    putCustomerOrderChargesInfoUpdate(
      storeCustomerId,
      storeId,
      bookingOrderId,
      data
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const message = Res.message;
          const status = Res.status;
          fetchGarmentEditData();
          if (status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText(message);
          } else {
            setModalVisible(true);
            setModalStatus("not Success");
            setModalText(message);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const renderCardItem = () => {
    return discountData?.map((item, index) => {
      const isEven = index % 2 === 0;

      const gradientColors = isEven
        ? "radial-gradient(circle at left top, #8a2387, #e94057)"
        : "radial-gradient(circle at left top, #fa709a, #fee140)";

      return (
        <div>
          <div>
            <div className="ml-6">
              <div
                className=" flex flex-1 my-1 mx-1 border-round-3xl shadow-4 my-2"
                style={{
                  backgroundImage: gradientColors,
                }}
              >
                <div className="flex flex-1 grid justify-content-between align-items-center ml-3 mt-0">
                  <p className="col text-lg text-white font-medium capitalize">
                    {item.name?.replace(/_/g, " ")}
                  </p>
                  <p className="col text-lg text-white font-medium capitalize">
                    {storeLocalData?.currencySymbol} {item.amount}
                  </p>
                  <div className="flex col text-lg text-white font-medium capitalize gap-3">
                    {enabledChargeDiscountByService &&
                      item.chargeDiscountTypeIn === "AMOUNT" &&
                      item.orderChargeDiscountMode === "BOOKING" && (
                        <div
                          onClick={() => {
                            setDiscountAmountPreviousValue(item);
                            setBookingInfoChargesEditModalVisible(true);
                          }}
                        >
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#fff",
                            }}
                          ></i>
                        </div>
                      )}

                    {item.amount > 0 && (
                      <div
                        onClick={() => {
                          handleRemoveAppliedCharge(item);
                        }}
                      >
                        <i
                          className="pi pi-trash"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                        ></i>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_STORE" ?
                       navigate("/OrdersGarmentInfo", {
                          state: {
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                          },
                        })
                      : navigate(-1);
                    }
                    
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Applied Discount
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <div>
            <div>
              <div className="ml-6">
                <div
                  className=" flex flex-1 my-1 mx-1 border-round-3xl shadow-4 mt-2 mb-3"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #6b88f2, #1742db)",
                  }}
                >
                  <div className="flex flex-1 grid justify-content-between align-items-center ml-3 mt-0">
                    <div className="col">
                      <p className="text-xl text-white font-bold capitalize">
                        Name
                      </p>
                    </div>
                    <p className="col text-xl text-white font-bold capitalize">
                      Amount
                    </p>
                    <div className="col text-xl text-white font-bold capitalize">
                      {enabledChargeDiscountByService && (
                        <div
                          onClick={() => {
                            setBookingInfoChargesAddModalVisible(true);
                          }}
                        >
                          <i
                            className="pi pi-plus-circle"
                            style={{
                              fontSize: "25px",
                              cursor: "pointer",
                              color: "#fff",
                            }}
                          ></i>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>{renderCardItem()}</div>
        </div>
        <BookingInfoDiscountsEdit
          setBookingInfoChargesEditModalVisible={
            setBookingInfoChargesEditModalVisible
          }
          bookingInfoChargesEditModalVisible={
            bookingInfoChargesEditModalVisible
          }
          sendDataToBookingInfoChargesEdit={receiveDataFromBookingInfoCharges}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
          storeId={storeId}
          discountAmountPreviousValue={discountAmountPreviousValue}
        />

        {bookingInfoChargesAddModalVisible && (
          <BookingInfoDiscountsAdd
            setBookingInfoChargesAddModalVisible={
              setBookingInfoChargesAddModalVisible
            }
            bookingInfoChargesAddModalVisible={
              bookingInfoChargesAddModalVisible
            }
            sendDataToBookingInfoChargesAdd={receiveDataFromBookingInfoCharges}
            storeCustomerId={storeCustomerId}
            bookingOrderId={bookingOrderId}
            storeId={storeId}
            discountData={discountData}
            userRole={userRole}
          />
        )}
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default BookingDiscountInfo;
